import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { AppModalDto } from "../../core/dto/generic.dto";

const AppModal = ({
    title,
    bodyText,
    primaryButtonLabel,
    secondaryButtonLabel,
    primaryButtonEventEmitter,
    secondaryButtonEventEmitter,
    disablePrimaryButton,
    disableSecondaryButton,
    children,
    hideFooter,
    showCloseButton = false,
    closeButtonEventEmitter,
    modalSize,
    stayAppear,
    bodyClassName,
    handOffLoader,
}: AppModalDto) => {
    const [show, setShow] = React.useState(false);

    const handleClose = React.useCallback(() => {
        !stayAppear && setShow(false);
        if (primaryButtonEventEmitter) {
            primaryButtonEventEmitter();
        }
    }, []);

    const handleManualClose = React.useCallback(() => {
        setShow(false);
        if (closeButtonEventEmitter) {
            closeButtonEventEmitter();
        }
    }, []);

    const handleSecondaryButtonClose = React.useCallback(() => {
        setShow(false);
        if (secondaryButtonEventEmitter) {
            secondaryButtonEventEmitter();
        }
    }, []);

    React.useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        };
    }, []);

    return (
        <Modal show={show} size={modalSize ? modalSize : "lg"} onHide={() => { showCloseButton && handleManualClose() }}>
            <Modal.Header closeButton={showCloseButton}>
                <Modal.Title style={{color:'#0187c4' }}>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={bodyClassName ? bodyClassName : ""}>
                {bodyText}
                {children && children}
            </Modal.Body>
            {
                !hideFooter && (
                    <Modal.Footer>
                        {primaryButtonLabel && (
                            <Button
                                variant="primary"
                                disabled={(handOffLoader || disablePrimaryButton) ? true : false}
                                onClick={handleClose}
                            >
                                {handOffLoader && <span className="spinner-border text-white mr-1" style={{ width: '15px', height: "15px" }} role="status"></span>}
                                {primaryButtonLabel}
                            </Button>
                        )}
                        {secondaryButtonLabel && (
                            <Button
                                variant="secondary"
                                onClick={handleSecondaryButtonClose}
                                disabled={(handOffLoader || disableSecondaryButton) ? true : false}
                            >
                                {secondaryButtonLabel}
                            </Button>
                        )}
                    </Modal.Footer>
                )
            }
        </Modal>
    );
};

export default AppModal;
